import find from 'lodash/find';
import React, { useContext, useState } from 'react';
import Data from '../data';
import Modal from '../modal';
import UI from '../ui';
import AddCarrierHeader from './AddCarrierHeader.component';
import AddDhlxAccount from './DHLx/AddDhlxAccount.component';
import { AddFedExAccount } from './FedEx/AddFedExAccount.component';
import AddUpsCarrier from './UPS/AddUpsCarrier.component';

const { ModalButtonActionType, ModalContext } = Modal;
const { Footer, Section, SectionBody, ButtonGrid } = UI;
const { Carrier, AllCarriers } = Data;

// create array of buttons for ButtonGrid
const createCarrierButtons = (availableCarriers, onClick, className) =>
	availableCarriers.map(carrier => {
		const carrierCls = carrier.replace(/_/g, '-');

		return {
			icon: `${carrierCls}-logo`,
			className,
			onClick: () => onClick(carrier),
			colWidth: 4,
			lgWidth: 3,
			dataqa: `${carrierCls}-logo`,
		};
	});

const AddNewCarrier = ({
	capable,
	configured,
	completionCallback,
	custId,
	enterpriseLocations,
	isSingleLocationSelected,
}) => {
	const [carrierValue, setCarrierValue] = useState('');
	const { showMessage } = useContext(ModalContext);

	const onButtonGridClick = carrier => {
		const usableLocations = [];

		if (enterpriseLocations) {
			for (let i = 0; i < enterpriseLocations.length; i++) {
				const currLocation = enterpriseLocations[i];

				if (
					!currLocation.ConfiguredCarriers?.some(
						item => item.carrier === carrier
					)
				) {
					usableLocations.push(currLocation);
				}
			}

			if (usableLocations.length < enterpriseLocations.length) {
				const { displayName } = find(AllCarriers, ['value', carrier]);

				showMessage({
					data: {
						title: 'Warning',
						description: `${enterpriseLocations.length - usableLocations.length} of ${
							enterpriseLocations.length
						} selected locations already have ${displayName} added. Remove those selection to proceed?`,
						primaryButtonType: ModalButtonActionType.Confirm,
						primaryButtonText: `Proceed with ${usableLocations.length} Locations`,
					},
					closeCallback: async closeType => {
						if (closeType === ModalButtonActionType.Confirm) {
							setCarrierValue(carrier);
						}
					},
				});
			} else {
				setCarrierValue(carrier);
			}
		} else {
			setCarrierValue(carrier);
		}
	};
	const availableCarriers = capable.filter(
		carrier => !configured.includes(carrier)
	);
	const carrierButtons = createCarrierButtons(
		availableCarriers,
		onButtonGridClick
	);

	const onCancelButtonClick = () => {
		completionCallback(false);
	};

	if (carrierValue === Carrier.UPS) {
		return (
			<AddUpsCarrier
				completionCallback={completionCallback}
				custId={custId}
				enterpriseLocations={enterpriseLocations}
				isSingleLocationSelected={isSingleLocationSelected}
			/>
		);
	} else if (carrierValue === Carrier.DHLExpress) {
		return (
			<AddDhlxAccount
				completionCallback={completionCallback}
				custId={custId}
				enterpriseLocations={enterpriseLocations}
			/>
		);
	} else if (carrierValue === Carrier.FedEx) {
		return <AddFedExAccount completionCallback={completionCallback} />;
	} else {
		return (
			<div className="common-carrier-add-new-carrier">
				<Section>
					<AddCarrierHeader
						title="Add New Carrier"
						carrier={carrierValue}
						subtitle="Select the carrier you would like to add:"
					/>
					<SectionBody>
						<ButtonGrid buttons={carrierButtons} dataqa="addcarrier" />
					</SectionBody>
					{!enterpriseLocations && (
						<Footer
							secondary={{
								label: 'Cancel',
								onClick: onCancelButtonClick,
								dataqa: 'add-carrier-cancel',
							}}
						/>
					)}
				</Section>
			</div>
		);
	}
};

export default AddNewCarrier;
